import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

import { styled } from "@mui/material/styles";

import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

import ButtonBlue from "../../../../shared/general/ButtonBlue";
import DialogConfirmDelete from "../../../../shared/general/DialogConfirmDelete";

import {
  getEmployeeProfile,
  getEmployeePersonnelLevelChange,
  addDeleteEmployeePersonnelLevel,
} from "../../../../../../actions/employee";

import { getLevelByidCompany } from "../../../../../../actions/level";

import DialogEdit from "./DialogEdit";
import FlowForm from "../components/flowForm";

const StyledRoot = styled("div")({
  "& .salary": {
    "& .MuiTypography-h6": {
      marginRight: 8,
    },
    display: "flex",
    alignItems: "baseline",
  },
});

const StyledHeadLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

const StyledWrapTop = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  marginBottom: 16,
  "& .MuiTypography-body2": {
    margin: 0,
  },
});

const StyledDivider = styled(Divider)({
  marginTop: 16,
  marginBottom: 16,
  borderWidth: "0px 0px thin",
  borderColor: "#919eab52",
  borderStyle: "dashed",
  width: "100%",
});

const StyledWrapChange = styled("div")({
  marginTop: 8,
  "& .inner": {
    marginBottom: 8,
  },
  "& .first-line": {
    display: "flex",
    "& .date": {
      margin: "0 8px",
      fontWeight: 600,
    },
    "& .positions-name": {
      fontWeight: 600,
    },
  },
  "& .second-line": {
    marginLeft: 16,
    fontSize: 16,
  },
});

function PersonnelLevelChange() {
  const dispatch = useDispatch();
  const { result: employeeProfile } = useSelector(
    (state) => state.employeeProfile
  );

  const { result: employeePersonnelLevelChangeList } = useSelector(
    (state) => state.employeeChange
  );

  const [openEdit, setOpenEdit] = useState(false);
  const [mode, setMode] = useState("add");
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [disabledBtnDelete, setDisabledBtnDelete] = useState(false);
  const [disabledBtnChange, setDisabledBtnChange] = useState(false);

  const [drawerConfig, setDrawerConfig] = useState({
    isOpen: false,
    isEdit: false,
    data: {}
  })

  const [drawerEditConfig, setDrawerEditConfig] = useState({
    isOpen: false,
    isEdit: false,
    data: {}
  })

  useEffect(() => {
    dispatch(getEmployeePersonnelLevelChange(employeeProfile.idEmployees));
    dispatch(getLevelByidCompany());
  }, []);

  useEffect(() => {
    if (employeePersonnelLevelChangeList && employeePersonnelLevelChangeList.length > 0) {
      if (
        dayjs(
          employeePersonnelLevelChangeList[
            employeePersonnelLevelChangeList.length - 1
          ].start
        ).isSameOrAfter(dayjs().toDate(), "date")
      ) {
        setDisabledBtnChange(true);
      } else {
        setDisabledBtnChange(false);
      }
    }
  }, [employeePersonnelLevelChangeList]);

  const handleDeletePersonnelLevel = (dataform) => {
    setSelectedItem(dataform);
    setOpenDialogDelete(true);
  };

  const handleOpenDialog = () => {
    setOpenEdit(true);
    setMode("add");
    setDrawerConfig(prev => ({
      ...prev,
      isOpen: true,
      isEdit: false,
    }))
  };
  const handleCloseDialog = () => {
    setOpenEdit(false);
    setOpenDialogDelete(false);
    setDrawerConfig(prev => ({
      ...prev,
      isOpen: false,
    }))
  };

  const handleEditPersonnelLevel = (dataform) => {
    handleOpenDialog()
    setSelectedItem(dataform);
    setMode("edit")
  } 

  const handleSubmit = async () => {
    setDisabledBtnDelete(true);
    let tempFormData = { ...selectedItem };
    tempFormData.method = "delete";
    tempFormData.isFirst = employeePersonnelLevelChangeList.length === 1;
    tempFormData.idEmployeePersonnelLevelBefore =
      employeePersonnelLevelChangeList.length === 1
        ? null
        : employeePersonnelLevelChangeList[
            employeePersonnelLevelChangeList.length - 2
          ].idEmployeePersonnelLevel;
    tempFormData.start = dayjs(tempFormData.start).format("YYYY-MM-DD");

    const result = await dispatch(
      addDeleteEmployeePersonnelLevel(tempFormData)
    );
    if (result) {
      handleCloseDialog();
      dispatch(getEmployeePersonnelLevelChange(employeeProfile.idEmployees));
      dispatch(getEmployeeProfile(employeeProfile.idEmployees, true));
    }
  };

  return (
    <StyledRoot>
      <StyledWrapTop>
        <div>
          <ButtonBlue
            variant="text"
            size="small"
            startIcon={<EditIcon />}
            onClick={handleOpenDialog}
            disabled={disabledBtnChange}
          >
            ปรับระดับ
          </ButtonBlue>
        </div>
      </StyledWrapTop>
      {employeeProfile && <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <div>
            <StyledHeadLabel color="text.secondary">กลุ่มระดับ</StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.personnelLevelGroupName
                ? employeeProfile.personnelLevelGroupName
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div>
            <StyledHeadLabel color="text.secondary">ระดับ</StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.personnelLevelName
                ? employeeProfile.personnelLevelName
                : "-"}
            </Typography>
          </div>
        </Grid>
      </Grid>}
      <StyledDivider />
      <div>
        <StyledHeadLabel color="text.secondary">
          บันทึกการเปลี่ยนแปลง
        </StyledHeadLabel>
        {employeePersonnelLevelChangeList &&
        employeePersonnelLevelChangeList.length > 0 ? (
          <StyledWrapChange>
            {employeePersonnelLevelChangeList.map((item, index) => (
              <div className="inner" key={index}>
                <div className="first-line">
                  <Box display="flex" alignItems="center" flexGrow="1">
                    <div>
                      {employeePersonnelLevelChangeList.length - 1 === index ? (
                        <Fragment>
                          <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => handleDeletePersonnelLevel(item)}
                            disabled={employeePersonnelLevelChangeList.length === 1}
                          >
                            <HighlightOffRoundedIcon fontSize="inherit" />
                          </IconButton>
                          <IconButton
                            aria-label="edit"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDrawerEditConfig(prev => ({
                                ...prev,
                                isOpen: true,
                                isEdit: true,
                                data: {
                                  idEmployeePersonnelLevel: item.idEmployeePersonnelLevel,
                                  idLevel: item.idLevel,
                                  start: item.start,
                                  remark: item.remark,
                                }
                              }))
                            }}
                          >
                            <EditNoteRoundedIcon fontSize="inherit" />
                          </IconButton>
                        </Fragment>
                      ) : null}
                    </div>
                    &nbsp;
                    {item.end ? (
                      <Typography className="date" color="text.third">
                        {`[${dayjs(item.start)
                          .locale(localStorage.getItem("language") || "en")
                          .format(
                            localStorage.getItem("language") === "th"
                              ? "DD MMM BBBB"
                              : "DD MMM YYYY"
                          )} - ${dayjs(item.end)
                          .locale(localStorage.getItem("language") || "en")
                          .format(
                            localStorage.getItem("language") === "th"
                              ? "DD MMM BBBB"
                              : "DD MMM YYYY"
                          )}]`}
                      </Typography>
                    ) : (
                      <Typography className="date" color="text.third">
                        {`[${dayjs(item.start)
                          .locale(localStorage.getItem("language") || "en")
                          .format(
                            localStorage.getItem("language") === "th"
                              ? "DD MMM BBBB"
                              : "DD MMM YYYY"
                          )} - ปัจจุบัน]`}
                      </Typography>
                    )}
                    <Typography className="positions-name">
                      {`${item.groupLevelName} : ${item.levelName}`}
                    </Typography>
                  </Box>
                </div>
                <Typography
                  color="text.secondary"
                  variant="body2"
                  className="second-line"
                  style={{ fontStyle: "oblique", paddingLeft: 64 }}
                  gutterBottom
                >
                  {`หมายเหตุ: ${item.remark ? item.remark : "-"}`}
                </Typography>
                <Typography
                  color="text.secondary"
                  variant="body2"
                  className="second-line"
                  align="right"
                  style={{ fontStyle: "oblique" }}
                  gutterBottom
                >
                  {`วันที่แก้ไขข้อมูล: ${
                    item.updateDate
                      ? dayjs(item.updateDate)
                          .locale(localStorage.getItem("language") || "en")
                          .format(
                            localStorage.getItem("language") === "th"
                              ? "DD MMM BBBB HH:mm"
                              : "DD MMM YYYY HH:mm"
                          )
                      : "-"
                  }`}
                </Typography>
              </div>
            ))}
          </StyledWrapChange>
        ) : (
          <StyledWrapChange>
            <Typography
              align="center"
              color="text.secondary"
              variant="body2"
              className="second-line"
              style={{ fontStyle: "oblique", marginTop: 32 }}
              gutterBottom
            >
              ไม่มีการเปลี่ยนแปลง
            </Typography>
          </StyledWrapChange>
        )}
      </div>

      {/* <DialogEdit open={openEdit} mode={mode} selectedItem={selectedItem} handleCloseDialog={handleCloseDialog} /> */}

      {/* <DialogEdit
        open={drawerConfig.isOpen}
        handleCloseDialog={handleCloseDialog}
        drawerConfig={drawerConfig}
      /> */}

      <FlowForm
        // open={drawerConfig.isOpen}
        handleClose={handleCloseDialog}
        drawerConfig={drawerConfig}
        defaultPage="personnelLevel"
      />

      <DialogEdit
        open={drawerEditConfig.isOpen}
        drawerConfig={drawerEditConfig}
        handleCloseDialog={() => {
          setDrawerEditConfig((prev) => ({
            ...prev,
            isOpen: false
          }))
        }}
      />


      {selectedItem && (
        <DialogConfirmDelete
          open={openDialogDelete}
          handleClose={handleCloseDialog}
          label={`ระดับพนักงาน`}
          text={`${selectedItem.groupLevelName}: ${selectedItem.levelName}`}
          handleDelete={handleSubmit}
          disabledBtnDelete={disabledBtnDelete}
        />
      )}
    </StyledRoot>
  );
}

export default PersonnelLevelChange;
